import { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { useAuth } from '../../contexts/AuthContext'
import './auth.css'

export default function LoginPage() {
  const auth = useAuth()
  const navigate = useNavigate()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [submitting, setSubmitting] = useState(false)

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    setError('')
    if (!email.trim()) {
      setError('Please enter your email.')
      return
    }
    if (!password) {
      setError('Please enter your password.')
      return
    }
    if (!auth) {
      setError('Sign-in is not configured. Add VITE_FIREBASE_* to your .env file.')
      return
    }
    if (auth.authError) {
      setError(auth.authError)
      return
    }
    setSubmitting(true)
    try {
      await auth.login(email.trim(), password)
      navigate('/app', { replace: true })
    } catch (err: unknown) {
      const code = err && typeof err === 'object' && 'code' in err ? (err as { code: string }).code : ''
      const message =
        code === 'auth/configuration-not-found'
          ? 'Firebase Auth is not configured. Check your .env (VITE_FIREBASE_*) and enable Authentication in Firebase Console.'
          : code === 'auth/invalid-credential'
            ? 'Invalid email or password.'
            : code === 'auth/invalid-email'
              ? 'Invalid email address.'
              : (err as { message?: string })?.message ?? 'Sign-in failed.'
      setError(message)
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <div className="auth-page">
      <div className="auth-card">
        <h1 className="auth-title">Sign in</h1>
        <p className="auth-subtitle">Sign in to your account</p>
        <form onSubmit={handleSubmit} className="auth-form">
          {(error || auth?.authError) && (
            <div className="auth-error" role="alert">
              {error || auth?.authError}
            </div>
          )}
          <label className="auth-label">
            Email
            <input
              type="email"
              className="auth-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoComplete="email"
              autoFocus
            />
          </label>
          <label className="auth-label">
            Password
            <input
              type="password"
              className="auth-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
            />
          </label>
          <div className="auth-actions">
            <button
              type="submit"
              className="auth-btn auth-btn--primary"
              disabled={submitting}
            >
              {submitting ? 'Signing in…' : 'Sign in'}
            </button>
          </div>
        </form>
        <p className="auth-footer">
          Don&apos;t have an account?{' '}
          <Link to="/register" className="auth-link">
            Create an account
          </Link>
        </p>
      </div>
    </div>
  )
}
